import axios from 'axios';
import Toast from '../component/toast';
import envConfig from '../envConfig'

// @ts-ignore
const env: string = process.env.REACT_APP_ENV
// @ts-ignore
let baseUrl = envConfig[env].api;

const instance = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
  headers: {'Content-Type': 'multipart/form-data'},
  withCredentials: false, // 允许携带cookie
  validateStatus(status) {
    return status < 500
  }
});

// 添加一个请求拦截器
instance.interceptors.request.use(
  request => {
    const token = localStorage.getItem('token') || '';
    if (process && process.env && process.env.REACT_APP_ENV !== 'dev') {
      request.headers.common['x-token'] = token
    }
    return request
  },
  err => Promise.reject(err)
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    const {code} = response.data;
    if (Number(code) === 0) {
      return Promise.resolve(response.data)
    } else {
      Toast(response.data.message || response.data.msg)
    }
    return Promise.reject(response.data)
  },
  err => {
    Toast('服务器报错')
    return Promise.reject(err)
  }
);

export default instance
